import { Button } from '@backstage/ui';
import { RiArrowDownSLine, RiArrowUpSLine } from '@remixicon/react';

import styles from './AzureCard.module.css';

type AzureShowAllToggleProps = {
  resourceType: string;
  showAll: boolean;
  onToggle: () => void;
};

export const AzureShowAllToggle = ({
  resourceType,
  showAll,
  onToggle,
}: AzureShowAllToggleProps) => {
  const ariaLabel = showAll ? `Show less ${resourceType}` : `Show more ${resourceType}`;
  const Icon = showAll ? RiArrowUpSLine : RiArrowDownSLine;

  return (
    <Button
      variant="tertiary"
      size="small"
      onPress={onToggle}
      aria-expanded={showAll}
      aria-label={ariaLabel}
      className={styles.showAllToggle}
    >
      <Icon aria-hidden="true" />
    </Button>
  );
};
